<template>
  <div class="well well--library">
    <div class="share-link-panel">
      <h4 class="share-link-header text-left">Share with colleagues or caregivers</h4>
      <button
        v-show="!goalShareStatus.shared"
        @click="shareGoal()"
        :disabled="sharing"
        class="btn btn-primary btn-block"><span v-if="!sharing"><i class="fa fa-link"/> Create a Shareable Link</span><span v-if="sharing"><i class="fa fa-circle-o-notch fa-spin fa-fw"/> Loading...</span></button>
      <div v-if="goalShareStatus.shared">
        <p class="share-link-warning"><i class="fa fa-eye"/> Anyone with the link can view<br><a
          class="make-private"
          v-if="editorVisibility"
          @click="unshareGoal()"
          role="button"><small>Make private</small></a></p>
        <p class="input-group">
          <span class="input-group-addon"><i class="fa fa-link"/></span>
          <input
            @focus="$event.target.select()"
            type="text"
            class="form-control shared-link-display"
            readonly
            :value="goalShareStatus.shareLink">
        </p>
        <CopyButton
          @copied="shareLinkCopied"
          :copy-text="goalShareStatus.shareLink"
          success-text="Link copied"
          btn-class="btn btn-default btn-block">
          <i class="fa fa-link" aria-hidden="true"/> Copy Link
        </CopyButton>
      </div>
    </div>
    <LimitActionModal :show.sync="showBlocker" :action-permissions="actionPermissions.shareSavedGoal" />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { shareGoal, unshareGoal } from '@/api/goaldetail'
import { CONTENT_TYPES } from '@/util/access_visibility'
import LimitActionModal from '@/components/LimitActionModal'
import CopyButton from '@/components/CopyButton'

export default {
  name: 'ShareGoalPanel',
  components: {
    CopyButton,
    LimitActionModal
  },
  data() {
    return {
      sharing: false,
      showBlocker: false
    }
  },
  eventContext() {
    return {
      type: this.contentType,
      uuid: this.uuid,
      share_link: this.goalShareStatus.shareLink
    }
  },
  props: {
    uuid: {
      required: true,
      type: String
    },
    sourceUuid: {
      required: true,
      type: String
    },
    anchorPage: {
      required: true,
      type: Boolean
    }
  },
  computed: {
    ...mapGetters('visibility', ['editorVisibility']),
    ...mapGetters('goaldetail', ['actionPermissions']),
    ...mapState('customgoal', { shareStatus: state => state.shareStatus }),
    ...mapState('customanchor', { shareAnchorStatus: state => state.shareStatus }),
    saveAction() {
      return this.anchorPage ? 'customanchor/setShareStatus' : 'customgoal/setShareStatus'
    },
    goalShareStatus() {
      return this.anchorPage ? this.shareAnchorStatus : this.shareStatus
    },
    contentType() {
      return this.anchorPage ? CONTENT_TYPES.SAVED_SUPER_PAGE : CONTENT_TYPES.SAVED_GOAL
    }
  },
  methods: {
    shareGoal() {
      if (this.actionPermissions.shareSavedGoal.block) {
        this.showBlocker = true
        return
      }
      this.sharing = true
      shareGoal(this.uuid).then(data => {
        this.$store.commit(this.saveAction, {
          shared: true,
          shareLink: data.share_link
        })
        this.$sendEvent('Library Goal Shared')
        this.$sendEvent('Created Share Link for Saved Goal', {uuid: this.uuid})
        this.sharing = false
      })
      this.$sendEvent('Clicked Create Share Link')
    },
    unshareGoal() {
      unshareGoal(this.uuid).then(data => {
        if (data) {
          this.$store.commit(this.saveAction, {
            shared: false
          })
        }
      })
    },
    shareLinkCopied() {
      this.$sendEvent('Copied Share Link', {
        share_content_type: this.contentType
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/variables.less';
.share-link-warning {
  padding: 10px 0;
  background-color: @brand-primary;
  border: 1px solid @gray-lighter;
  border-radius: 4px;
  color: white;
}
.share-link-panel {
  text-align: center;
}
.shared-link-display {
  overflow: hidden;
  cursor: text;
}
.well--library {
  background: @libraryColorBg;
  padding-top: 10px;
  h4 {
    color: @libraryColorText;
    margin-bottom: 8px;
  }
}
.make-private {
  color: @gray-lighter;
}
</style>
